/**
 * AnalyticsService - Wrapper for Firebase Analytics
 */

// Firebase is loaded from CDN as global
declare const firebase: any;

export class AnalyticsService {
    private analytics: any;

    constructor() {
        if (typeof firebase !== 'undefined' && firebase.analytics) {
            this.analytics = firebase.analytics();
        }
    }

    /**
     * Tracks welcome dialog action
     */
    logWelcomeAction(action: 'start_with_bib' | 'start_demo', bibProvided: boolean): void {
        this.analytics?.logEvent('welcome_action', {
            action,
            bib_provided: bibProvided
        });
    }

    /**
     * Tracks stage navigation
     */
    logStageNavigation(stage: number, direction: 'next' | 'previous' | 'dot_click'): void {
        this.analytics?.logEvent('stage_navigation', {
            stage,
            direction
        });
    }

    /**
     * Tracks filter application
     */
    logFilterApplied(filterType: 'category' | 'distance' | 'age_group', value: string): void {
        this.analytics?.logEvent('filter_applied', {
            filter_type: filterType,
            filter_value: value
        });
    }

    /**
     * Tracks athlete search
     */
    logAthleteSearch(searchType: 'bib' | 'name', hasResults: boolean): void {
        this.analytics?.logEvent('athlete_search', {
            search_type: searchType,
            has_results: hasResults
        });
    }

    /**
     * Tracks athlete selection
     */
    logAthleteSelected(bib: number, category: string, distance: string, stage: number): void {
        this.analytics?.logEvent('athlete_selected', {
            bib,
            category,
            distance,
            stage
        });
    }

    /**
     * Tracks ranking mode change
     */
    logRankingModeChanged(mode: 'cumulative' | 'individual'): void {
        this.analytics?.logEvent('ranking_mode_changed', {
            mode
        });
    }

    /**
     * Tracks auto-play started
     */
    logAutoPlayStarted(): void {
        this.analytics?.logEvent('auto_play_started');
    }
}
